import { createStore } from "zustand/vanilla";

/**
 * トースト1件。`kind` は Toast の見た目（左罫線色）に対応。
 *
 * `info`（青）は成功でも失敗でもない知らせのためにある。たとえば「同名の資料が登録済み」は操作を
 * 止めない注意なので、赤（失敗）で出すと意味がずれる。
 */
export type ToastItem = { id: number; message: string; kind: "success" | "error" | "info" };

type ToastState = {
    toasts: ToastItem[];
    push: (message: string, kind: ToastItem["kind"]) => void;
    dismiss: (id: number) => void;
};

let seq = 0;

/**
 * 操作後の確認フィードバック（C-9-1）のためのモジュール単一トーストストア。
 * ペインから注入せず `notify(...)` をどこからでも呼べるようにする（UIの揮発状態でドメインではない）。
 */
export const toastStore = createStore<ToastState>((set) => ({
    toasts: [],
    push: (message, kind) => {
        const id = ++seq;
        set((s) => ({ toasts: [...s.toasts, { id, message, kind }] }));
        setTimeout(() => {
            set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
        }, 3500);
    },
    dismiss: (id) =>
        set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));

/** 成功/失敗のトーストを出す。既定は成功。 */
export function notify(message: string, kind: ToastItem["kind"] = "success") {
    toastStore.getState().push(message, kind);
}
